import { getMobileAndDesktopFirstImage } from 'components/PageSections/utils';

import { BannerWithBulletPointsProps } from './BannerWithBulletPoints';

export function parseBannerWithBulletPoints(
  section: Queries.ContentfulSection001,
): BannerWithBulletPointsProps {
  const { metadata, images } = section;

  const sectionImages = getMobileAndDesktopFirstImage(images ?? null);

  const subsections = section?.subsections as Queries.ContentfulSection001[];

  return {
    title: metadata?.title ?? null,
    titleColor: metadata?.theme?.primaryColor ?? null,
    description: metadata?.description?.description ?? null,
    descriptionColor: metadata?.theme?.secondaryColor ?? null,
    backgroundColor: metadata?.theme?.backgroundColor ?? null,
    bulletPoints: subsections?.map((subsection) => ({
      text: subsection?.metadata?.title ?? null,
      textColor: subsection?.metadata?.theme?.textColor ?? null,
      iconName: subsection?.metadata?.context?.iconName ?? null,
      iconColor: subsection?.metadata?.context?.iconColor ?? null,
    })),
    mobileImage: sectionImages.mobileImage,
    desktopImage: sectionImages.desktopImage,
    cta: metadata?.ctas?.[0] ?? null,
  };
}
